import { render, staticRenderFns } from "./CoolFrame.vue?vue&type=template&id=32eb5a86&scoped=true"
import script from "./CoolFrame.vue?vue&type=script&lang=js"
export * from "./CoolFrame.vue?vue&type=script&lang=js"
import style0 from "./CoolFrame.vue?vue&type=style&index=0&id=32eb5a86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eb5a86",
  null
  
)

export default component.exports